import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../app/pages/pages';
import { AuthGuard } from '../app/services/auth-guard';
import { AuthenticatedGuard } from '../app/services/authenticated.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MonitorsComponent } from './pages/monitors/monitors.component';
import { PrivilegeComponent } from './pages/privilege/privilege.component';
import { RolesComponent } from './pages/roles/roles.component';
import { SitesComponent } from './pages/sites/sites.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { SiteDetailsComponent } from './pages/sites/site-details/site-details.component';
import { GraphStatsComponent } from './pages/graph-stats/graph-stats.component';
import { SiteOverviewComponent } from './pages/site-overview/site-overview.component';
import { SdtFormComponent } from './pages/sdt-form/sdt-form.component';
import { SdtDetailsComponent } from './pages/sdt-details/sdt-details.component';
import { NetworkMetricsComponent } from './pages/network-metrics/network-metrics.component';
import { ZendeskCommentsComponent } from './pages/zendesk-comments/zendesk-comments.component';
import { PmFormComponent } from './pages/pm-form/pm-form.component';
import { PmDetailsComponent } from './pages/pm-details/pm-details.component';
import { HelpComponent } from './pages/help/help.component';
import { JiraProjectReportsComponent } from './pages/jira-project-reports/jira-project-reports.component';

const routes: Routes = [
  { path: '', component: LoginComponent, pathMatch:'full' },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: GraphStatsComponent, canActivate: [AuthGuard] },
  { path: 'sites', component: SitesComponent, canActivate: [AuthGuard] },
  { path: 'sites/:id', component: SitesComponent, canActivate: [AuthGuard] },
  { path: 'monitors/:id', component: MonitorsComponent, canActivate: [AuthGuard] },
  { path: 'monitors', component: MonitorsComponent, canActivate: [AuthGuard] },
  { path: 'privilege', component: PrivilegeComponent , canActivate: [AuthGuard]},
  { path: 'roles', component: RolesComponent, canActivate: [AuthGuard] },
  { path: 'user-management', component: UserManagementComponent, canActivate: [AuthGuard] },
  { path: 'zendesk-comments', component: ZendeskCommentsComponent, canActivate: [AuthGuard] },
  { path: 'sites/details', component: SiteDetailsComponent, canActivate: [AuthGuard] },
  { path: 'sites/details/:id', component: SiteDetailsComponent, canActivate: [AuthGuard] },
  { path: 'site-overview', component: SiteOverviewComponent, canActivate: [AuthGuard] },
  { path: 'cloud-infrastructure',component:NetworkMetricsComponent, canActivate: [AuthGuard]},
  { path: 'help',component:HelpComponent,canActivate:[AuthGuard]},
  { path: 'sdt-form', component: SdtFormComponent},
  { path: 'sdt-details', component: SdtDetailsComponent},
  { path: 'planned-maintenance-form', component:PmFormComponent},
  { path: 'planned-maintenance-details', component:PmDetailsComponent},
  { path: 'jira-reports', component: JiraProjectReportsComponent, canActivate: [AuthGuard] },
  { path: 'camera-server', loadChildren: () => import("./camera-server/camera-server.module").then(m => m.CameraServerModule), canActivate: [AuthGuard] },
  { path: 'cp', loadChildren: () => import("./components/user-behaviour/user-behaviour.module").then(m => m.UserBehaviourModule), canActivate: [AuthenticatedGuard] },
  { path: '**', redirectTo: 'login' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
